export default "__VITE_ASSET__fc6474c2__"